import { Theme } from '@mui/material';
import styled from '@emotion/styled';

import { Typography } from '@mui/material';

type ParamsStyle = {
    theme?: Theme;
}

export const BrDesk = styled.br(
    ({ theme }: ParamsStyle) => `
   display: none;

   @media(min-width: ${theme?.breakpoints.values.md}px) {
      display: block;
   }
`);

export const TypographyCustom = styled(Typography)(`
    position: relative;
    font-size: .875rem;
    line-height: 1.2;
    color: #1C386B;

    a {
        text-decoration: none;
        color: #1C386B;
    };
    
    img {
        position: absolute;
        bottom: 1px;
        margin: 0 3px;
    }
`);
